import { useRef } from 'react';
import { useProperty, useTranslation } from '@eti/providers';
import { useLinksAccessibility } from '../../custom-hooks/useLinkAccessibility';
import { ProductCardLayoutType } from '../models/product';
import getTranslatedTexts from '../text-resolvers/utils/getTranslatedTexts';
import { getModal, getPriceProps, getReadMoreLabel, getSingleChoiceProps, getUpsellProps } from '../utils/productCardProps';
import { useIllustration, usePictogram } from '../utils/useIllustration';
import { useProductSnowplowTracking } from '../../custom-hooks/useProductSnowplowTracking';
import { getProduct } from '../../single-choice/utils/singleChoiceTransformer';
export const useProductData = _ref => {
  var _order$persuasion;
  let {
    productId,
    order,
    productName,
    productPosition,
    isSelected,
    form,
    sellSpecification,
    texts,
    productType = 'none',
    layoutType
  } = _ref;
  const {
    p
  } = useProperty();
  const {
    t,
    nonDebugT
  } = useTranslation();
  const illustrationUrl = useIllustration(productName);
  const pictogramUrl = usePictogram(productName);
  const rootElement = useRef(null);
  useProductSnowplowTracking(productName, {
    productPosition,
    rootElement
  });
  const translation = getTranslatedTexts(texts, t);
  const readMoreButtonLabel = getReadMoreLabel(t);
  const extraProps = getSingleChoiceProps(t, p, nonDebugT);
  useLinksAccessibility({
    targetElement: rootElement,
    productTitle: translation.title
  });
  const product = getProduct(productId, order, productType);
  if (!product) {
    return {
      productData: null,
      rootElement,
      translation
    };
  }
  const {
    priceRaw
  } = product;
  const {
    priceLabel,
    price,
    priceSuffix
  } = getPriceProps(t, isSelected, product);
  const {
    abstractContent,
    additionalInformation,
    readMoreContent,
    title,
    confirmText = '',
    declineText = '',
    persuasionContent = '',
    confirmationContent = '',
    upSell
  } = translation;
  const productCardModal = getModal((_order$persuasion = order.persuasion) === null || _order$persuasion === void 0 ? void 0 : _order$persuasion.isEnabled, confirmationContent, persuasionContent);
  const {
    upSellObject,
    isUpsellHighlight = false,
    shouldDisplayUpsell = false
  } = getUpsellProps(upSell);
  const modalText = {
    confirmText,
    declineText
  };
  const isSmallCardLayout = layoutType === ProductCardLayoutType.Small;
  const productData = {
    description: abstractContent,
    additionalInformation,
    extraProps,
    form,
    illustrationUrl: isSmallCardLayout ? pictogramUrl : illustrationUrl,
    isHighlighted: isUpsellHighlight,
    isSelected,
    price,
    priceLabel,
    priceRaw,
    priceSuffix,
    productCardModal,
    productId,
    productName,
    productPosition,
    readMoreButtonLabel,
    readMoreContent,
    sellSpecification,
    shouldDisplayUpsell,
    title,
    travelers: order.travelers,
    upSell: upSellObject,
    layoutType,
    modalText
  };
  return {
    productData,
    rootElement,
    translation
  };
};
//# sourceMappingURL=useProductData.js.map